export var PACKAGE_VERSION = "9.7.0";
//# sourceMappingURL=constants.js.map